import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "channels",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const channel = require("./Channels").default;
          cb(null, channel);
        },
        "Channels"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/Channels/index.js